var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cve-name-and-link-table-cell"},[_c('div',{staticClass:"cve-name-and-link-table-cell__name"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }